import React from 'react';
import { ChakraV3 } from '..';

interface Props extends ChakraV3.BadgeProps {
  count: number;
}

export const NumberedBadge = (props: Props) => {
  const { count, ...rest } = props;

  const colorPalette = count > 0 ? 'brand' : 'gray';

  return (
    <ChakraV3.Badge
      borderRadius='full'
      px='2'
      colorPalette={colorPalette}
      alignSelf='center'
      {...rest}
      >
      {count}
    </ChakraV3.Badge>
  );
};
